import type { LmsTrainingPlain } from 'src/interfaces/collectStepReference'
import type { State } from '../reducers/types'

/**
 * Returns the stored array by reference. Never build a new array or object literal in a
 * selector — every consuming `useSelector` would re-render on each dispatch. Filtering and
 * sorting belong in the component under `useMemo`.
 *
 * Not to be confused with `getLmsTrainingsPlain` in `selectors/collectStepReference.ts`, which
 * reads the flow editor's own partner-scoped copy of this catalog.
 */
export const getLmsTrainings = (state: State): LmsTrainingPlain[] => {
  return state.lmsTraining.lmsTrainings
}

export const getLmsTrainingsLoading = (state: State): boolean => {
  return state.lmsTraining.lmsTrainingsLoading
}

export const getLmsTrainingsError = (state: State): string | null => {
  return state.lmsTraining.lmsTrainingsError
}

export const getLmsTrainingSaving = (state: State): boolean => {
  return state.lmsTraining.saving
}

export const getLmsTrainingDeletingId = (state: State): string | null => {
  return state.lmsTraining.deletingId
}
